import { render } from "./CloseX.vue?vue&type=template&id=560a10ce&ts=true"
import script from "./CloseX.vue?vue&type=script&lang=ts"
export * from "./CloseX.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__